/**
 * Clears coupon_code from URL params
 */
export const clearCouponCodeFromURL = () => {
    const params = new URLSearchParams(window.location.search);
    params.delete("coupon_code");
    const newUrl = window.location.pathname + (params.toString() ? `?${params.toString()}` : "");
    window.history.replaceState({}, "", newUrl);
};

/**
 * Handles coupon_code from URL parameter
 * - Scrolls to pricing section
 * - Types coupon code with animation
 * - Auto-applies and shows success popup
 */
export const handleCouponCodeFromURL = (query, setCouponCode) => {
    const urlCouponCode = query.get("coupon_code");

    if (!urlCouponCode) return;

    // Wait for page to fully render before starting
    const initialDelay = 1000;

    // Scroll to pricing/coupon input section
    setTimeout(() => {
        const pricingElement = document.getElementById("ppa-course-coupon-code-input");
        pricingElement?.scrollIntoView({
            behavior: "smooth",
            block: "center",
        });
    }, initialDelay);

    // Typing animation - start after scroll completes
    const timeOffsetToStart = initialDelay + 1000;
    const delayBetweenKeyStrokes = 150;

    for (let i = 0; i < urlCouponCode.length; i++) {
        const text = urlCouponCode.substring(0, i + 1);
        setTimeout(() => {
            const input = document.getElementById("ppa-course-coupon-code-input");
            if (input) {
                input.value = text;
                // Trigger input event for React to recognize the change
                input.dispatchEvent(new Event('input', { bubbles: true }));
            }
        }, timeOffsetToStart + i * delayBetweenKeyStrokes);
    }

    // After typing, set state and trigger apply
    const applyOffset = timeOffsetToStart + urlCouponCode.length * delayBetweenKeyStrokes + 500;

    setTimeout(() => {
        setCouponCode(urlCouponCode);

        // Glow the apply button
        const applyBtn = document.getElementById("ppa-course-apply-coupon-code-button");
        applyBtn?.classList.add("shining-button-to-attract-click");

        // Auto-click apply button after glow
        setTimeout(() => {
            applyBtn?.click();
        }, 800);

        // Remove glow after click
        setTimeout(() => {
            applyBtn?.classList.remove("shining-button-to-attract-click");
        }, 1500);
    }, applyOffset);
};
